import StorageDisclosureRow from './StorageDisclosureRow'

export default StorageDisclosureRow
